<template>
  <b-modal
    ref="modal"
    title="Resize"
    size="lg"
    @hide="closeHandler"
    @show="onShowHandler"
  >
    <template #modal-footer>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        Cancel
      </ButtonOutline>
      <ButtonPrimary
        variant="primary"
        :disabled="isLoading"
        @click="accept"
      >
        Resize
      </ButtonPrimary>
    </template>

    <div v-if="!isLoading">
      <div role="group">
        <label for="resize-width">Width</label>
        <b-form-input
          id="resize-width"
          v-model="width"
          type="number"
          @input="widthChangeHandler"
        />
      </div>

      <div
        role="group"
        class="mt-3"
      >
        <label for="resize-height">Height</label>
        <b-form-input
          id="resize-height"
          v-model="height"
          type="number"
          @input="heightChangeHandler"
        />
      </div>

      <b-form-checkbox
        v-model="isMaintainAspectRatio"
        class="mt-3"
        :value="true"
        :unchecked-value="false"
      >
        Maintain aspect ratio
      </b-form-checkbox>
      <b-form-checkbox
        v-model="isCopyBeforeResize"
        :value="true"
        :unchecked-value="false"
      >
        Copy before resize
      </b-form-checkbox>
    </div>

    <b-spinner v-else />
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from "./mixin"
import { createNamespacedHelpers } from 'vuex'
import {getSizeOfImgUrl} from "../../../../constants/image-calculations";
import Requests from "../../../../services/api/file-browser";
import {MUTATIONS} from "../../../../store/file-browser";

const { mapGetters, mapMutations, mapActions } = createNamespacedHelpers('fileBrowser')

const initState = () => ({
  width: 100,
  height: 100,
  originalWidth: 0,
  originalHeight: 0,
  isMaintainAspectRatio: true,
  isCopyBeforeResize: false,
  isLoading: false,
})

export default {
  name: "ResizeModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [
    mixinModal
  ],
  data: initState,
  computed: {
    ...mapGetters(['selectedItems'])
  },
  methods: {
    ...mapMutations([MUTATIONS.CLEAR_SELECTION, MUTATIONS.UPDATE_IS_PROCESSING]),
    ...mapActions(['fetchList']),
    reset() {
      const state = initState();
      for (const key in state) {
        this[key] = state[key];
      }
    },
    async onShowHandler() {
      this.reset();
      if (this.selectedItems.length > 1) {
        this.width = 0;
        this.height = 0;
      } else {
        const [width, height] = await getSizeOfImgUrl(this.selectedItems[0].url)
        this.originalWidth = this.width = width;
        this.originalHeight = this.height = height;
      }
    },
    widthChangeHandler() {
      if (this.selectedItems.length > 1 || !this.isMaintainAspectRatio) {
        return;
      }

      const ratioValue = this.width / this.originalWidth;

      this.height = Math.ceil(this.originalHeight * ratioValue);

    },
    heightChangeHandler() {
      if (this.selectedItems.length > 1 || !this.isMaintainAspectRatio) {
        return;
      }

      const ratioValue = this.height / this.originalHeight;

      this.width = Math.ceil(this.originalWidth * ratioValue)
    },
    async accept() {
      const options = {
        width: this.width,
        height: this.height,
        aspect_ratio: this.isMaintainAspectRatio ? 1 : 0,
        is_copy: this.isCopyBeforeResize ? 1 : 0,
      }
      const ids = this.selectedItems.map(({ id }) => id)
      this.isLoading = true;
      try {
        if (this.selectedItems.length === 1) {
          this[MUTATIONS.UPDATE_IS_PROCESSING]({id: this.selectedItems[0].id, isProcessing: 1, percentage: 99 });
          await Requests.resizeFolderFile(ids, options);
          setTimeout(() => {
            this.fetchList();
          }, 2000)
          toastr.success('File Resized!');
        } else {
          await Requests.resizeFolderFileUsingBackgroundJob(ids, options);
          toastr.success(
            "You will get an email when files are done converting!"
          );
        }
      } catch (error) {
        toastr.error('Something went wrong while resizing')
      } finally {
        this.close();
        this[MUTATIONS.CLEAR_SELECTION]();
      }
    }
  }
}
</script>


<style scoped lang="scss">

</style>
